const colors = {
    "primary-100": "#FEF9CD",
    "primary-200": "#FDF4A0",
    "primary-300": "#FBED6E",
    "primary-400": "#FAE73D",
    "primary-500": "#F9E10B",
    "primary-600": "#CCB805",
    "primary-700": "#9A8B04",
    "primary-800": "#685E03",
    "primary-900": "#322D01",
    "secondary-100": "#F0E6E0",
    "secondary-200": "#E1CABC",
    "secondary-300": "#D4B19B",
    "secondary-400": "#C89474",
    "secondary-500": "#BE7A50",
    "secondary-600": "#A36138",
    "secondary-700": "#834B2A",
    "secondary-800": "#63381D",
    "secondary-900": "#3C2110",
    "tertiary-100": "#FBFAF9",
    "tertiary-200": "#F4F3F0",
    "tertiary-300": "#F0EEEA",
    "tertiary-400": "#E9E7E2",
    "tertiary-500": "#E3E0D9",
    "tertiary-600": "#BFB8A6",
    "tertiary-700": "#9A8E74",
    "tertiary-800": "#685F4B",
    "tertiary-900": "#353027",
    "neutral-100": "#F5F5F5",
    "neutral-200": "#EBEBEB",
    "neutral-300": "#E0E0E0",
    "neutral-400": "#D6D6D6",
    "neutral-500": "#CCCCCC",
    "neutral-600": "#A3A3A3",
    "neutral-700": "#7A7A7A",
    "neutral-800": "#525252",
    "neutral-900": "#292929",
    "complementary01-100": "#F5F8E2",
    "complementary01-200": "#EAF1C1",
    "complementary01-300": "#DFE9A5",
    "complementary01-400": "#D5E283",
    "complementary01-500": "#CADB66",
    "complementary01-600": "#B7CF30",
    "complementary01-700": "#8B9D25",
    "complementary01-800": "#5B6718",
    "complementary01-900": "#30360D",
    "complementary02-100": "#F3F0FA",
    "complementary02-200": "#EAE4F7",
    "complementary02-300": "#DED5F1",
    "complementary02-400": "#D2C4ED",
    "complementary02-500": "#C6B5E8",
    "complementary02-600": "#9677D4",
    "complementary02-700": "#673CBE",
    "complementary02-800": "#462880",
    "complementary02-900": "#22143E",
    "complementary03-100": "#FFEFD6",
    "complementary03-200": "#FFDCA8",
    "complementary03-300": "#FFCC80",
    "complementary03-400": "#FFBA52",
    "complementary03-500": "#FFA929",
    "complementary03-600": "#EB8D00",
    "complementary03-700": "#B26B00",
    "complementary03-800": "#754600",
    "complementary03-900": "#3D2500",
    "complementary04-100": "#FDECEF",
    "complementary04-200": "#FAD6DC",
    "complementary04-300": "#F8C4CD",
    "complementary04-400": "#F5ADBA",
    "complementary04-500": "#F39BAB",
    "complementary04-600": "#EA536E",
    "complementary04-700": "#D51A3D",
    "complementary04-800": "#8D1127",
    "complementary04-900": "#490915",
    "complementary05-100": "#EFF2F5",
    "complementary05-200": "#DFE3EC",
    "complementary05-300": "#D0D7E2",
    "complementary05-400": "#C0C8D8",
    "complementary05-500": "#B1BCCF",
    "complementary05-600": "#8192B1",
    "complementary05-700": "#576B8E",
    "complementary05-800": "#3B485E",
    "complementary05-900": "#1D2430",
    "success-100": "#DDEEDD",
    "success-200": "#BADCBB",
    "success-300": "#98CB99",
    "success-400": "#76BA77",
    "success-500": "#54A756",
    "success-600": "#438544",
    "success-700": "#326433",
    "success-800": "#214322",
    "success-900": "#152A16",
    "info-100": "#D4E1F4",
    "info-200": "#A9C3E9",
    "info-300": "#7FA5DE",
    "info-400": "#5487D4",
    "info-500": "#3069C0",
    "info-600": "#265396",
    "info-700": "#1C3E71",
    "info-800": "#13294B",
    "info-900": "#0A1526",
    "warning-100": "#FFF2DA",
    "warning-200": "#FFE5B5",
    "warning-300": "#FFD790",
    "warning-400": "#FFCA6A",
    "warning-500": "#FFBD45",
    "warning-600": "#FFB020",
    "warning-700": "#D78B00",
    "warning-800": "#905D00",
    "warning-900": "#482E00",
    "danger-100": "#FFD5D7",
    "danger-200": "#FFAAAE",
    "danger-300": "#FF8086",
    "danger-400": "#FF555E",
    "danger-500": "#FF2B35",
    "danger-600": "#FF000D",
    "danger-700": "#BF000A",
    "danger-800": "#800006",
    "danger-900": "#400003",
    "report-100": "#DCD9FE",
    "report-200": "#BAB3FD",
    "report-300": "#978CFC",
    "report-400": "#7566FB",
    "report-500": "#5240FA",
    "report-600": "#1D06F5",
    "report-700": "#1605B8",
    "report-800": "#0F037A",
    "report-900": "#07023D",
};

const borderWidths = {
    "border-01": "1px",
    "border-02": "2px",
};

const fontSizes = {
    xs: "0.5rem",
    sm: "0.75rem",
    md: "1rem",
};

const radii = {
    sm: "4px",
    md: "8px",
};

const breaks = {
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1200,
};
const media = {
    xs: `(max-width: ${breaks.xs}px)`,
    sm: `(max-width: ${breaks.sm}px)`,
    md: `(max-width: ${breaks.md}px)`,
    lg: `(max-width: ${breaks.lg}px)`,
};

const shadows = {
    200: "0px 4px 6px -4px rgba(61, 33, 16, 0.12), 0px 8px 8px -4px rgba(61, 33, 16, 0.08);",
    400: "0px 6px 12px -6px rgba(61, 33, 16, 0.12), 0px 8px 24px -4px rgba(61, 33, 16, 0.08);",
    600: "0px 8px 18px -6px rgba(61, 33, 16, 0.12), 0px 12px 42px -4px rgba(61, 33, 16, 0.12);",
    800: "0px 8px 28px -6px rgba(61, 33, 16, 0.12), 0px 18px 88px -4px rgba(61, 33, 16, 0.14);",
};

const space = {
    "space-01": "0.125rem",
    "space-02": "0.25rem",
    "space-03": "0.5rem",
    "space-04": "0.75rem",
    "space-05": "1rem",
    "space-06": "1.5rem",
    "space-07": "2rem",
    "space-08": "2.5rem",
    "space-09": "3rem",
    "space-10": "4rem",
    "space-11": "5rem",
    "space-12": "6rem",
};

const defaultTheme = {
    colors,
    borderWidths,
    fontSizes,
    radii,
    shadows,
    space,
    media,
    breaks,
};
const getDefaultTheme = () => defaultTheme;
const createTheme = (theme) => theme;

export { createTheme, getDefaultTheme };
